import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { Subject } from 'rxjs/Subject';
import { Usuario } from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import swal from 'sweetalert2';
// import * as L from 'leaflet';
import 'leaflet-routing-machine';
import { FormControl } from '@angular/forms';

declare let L;
declare var $: any;

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: ['./cotizador.component.scss']
})
export class CotizadorComponent implements OnInit {
  // Propiedades de dataTable
  dtOptions: DataTables.Settings = {
    pageLength: 8,
    lengthChange: false,
    info: false
  };
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  // Form
  formCliente = '';
  formContacto = '';
  formObra = '';
  formTelefono = '';
  formCelular = '';
  formEmail = '';
  formDescripcion = '';
  formJustificacion = '';
  ordenTipo = '';
  formIva;

  // btn
  btnJustificacion = false;

  // Form
  idCliente = '';
  idContrato = '';
  fechaCotizacion = '';

  // Buscar
  pesoTotal: Number;

  // Array´s
  arrayProductos = [];
  arraySucursal = [];
  arrayVehiculos = [];
  selectProductos = [];
  productoATabla = [];
  material = [];
  articulo = [];
  buscarProducto = [];

  // Calculos
  rentaDiaria = 0;
  rentaDiariaImp;
  rentaSDias = 0;
  rentaSDiasImp;
  rentaQDias = 0;
  rentaQDiasImp;
  sumaPDias = 0;
  cantidadDelElemento: Number;
  porcentajeDescuento = 0;
  resultadoPorcentajeDescuento;
  resultadoPorcentajeDescuento2;
  porcentajeAumento = 0;
  resultadoPorcentajeAumento = 0;
  aumentoProducto = 0;

  // Cantidades
  sumaCantidad = 0;
  sumaCantidadImp;
  sumaRenta = 0;
  sumaRentaImp;
  sumaPeso = 0;
  sumaPesoImp;
  sumaVenta = 0;
  ventaTotal;
  montaje = 0;
  montajeImp;
  desmontaje = 0;
  desmontajeImp;
  fletes = 0;
  subTotal = 0;
  subtotalImp;
  costoTotal;
  numeroViajes = 0;
  unidadViaje = 0;
  fletesTotal = 0;
  diasDeRenta = 0;
  resultadoDiasRenta = 0;
  resultadoDiasRentaImp;
  fechaFin = moment().locale('es').format('LL');
  segundoProducto;
  abrirMapa = true;
  provider;
  resultados = [];
  otroArray = [];
  cantidadHoras = 0;
  cantidadHorasTotal = 0;
  cantidadHorasTotalImp;
  cantidadHorasTotalTotal = 0;
  cantidadHorasGlobal;
  rendimiento = 100;
  nRendimiento = 1;
  iva: Number;
  importeRentaImp;
  importePesoImp;

  model;

  // Coordenadas
  latitud = 0;
  longitud = 0;
  latitudSuc = 0;
  longitudSuc = 0;

  // Todo lo que tenga que ver con manos de obra
  altura = 10;
  personas = 0;
  manoDeObraCollapse = false;
  fletesCollapse = false;
  iconoMano = 'mdi-arrow-down-bold-circle-outline';
  iconoFlete = 'mdi-arrow-down-bold-circle-outline';
  jornales: number = 0;
  jornalesImp;
  sumaConceptos = 0;
  horasPersonas = 0;
  jornalesPersonas = 0;
  costoPersonasPorMontaje = 0;

  // Conceptos Varios
  Transporte = 0;
  Accesos = 0;
  Descargas = 0;
  Equipo = 0;
  Tiempos = 0;
  Preparacion = 0;
  Acarreos = 0;
  Estructuras = 0;
  Gastos = 0;
  Financiamiento = 0;
  Tramites = 0;
  Certificados = 0;
  Extras = 0;
  Inhabiles = 0;
  Viaticos = 0;
  Traslados = 0;
  Imprevistos = 0;
  Comidas = 0;
  costoTotalManoObra = 0;

  // Traslado
  avionCosto = 0;
  avionViajes = 0;
  autobusCosto = 0;
  autobusViajes = 0;
  barcoCosto = 0;
  barcoViajes = 0;
  taxiCosto = 0;
  taxiViajes = 0;
  otroCosto = 0;
  otroViajes = 0;

  avionCheck = false;
  barcoCheck = false;
  autobusCheck = false;

  checkRecoleccion = false;
  boolOrdenTipo = true;

  sumaAvion;
  sumaBarco;
  sumaTaxi;
  sumaAutobus;
  sumaOtro;
  totalTotal = 0;
  totalTotalImp;

  sumaTrasladosTotal = 0;
  sumaTrasladosTotalImp;
  pasarSumasTemporales = 0;
  pay;

  // Imprevistos
  imprevistos0 = '0%';
  imprevistos5 = '5%';
  imprevistos10 = '10%';
  imprevistos15 = '15%';
  imprevistos20 = '20%';
  // Imprevistos

  // FLETES
  vehiculoId = 0;
  distanciaMetros;
  precioGasolina;
  gastoCombustible = 0;
  gastoCombustibleVista = 0;
  gastoCombustibleVistaImp;
  gastoExtra = 0;
  cantidadColchon = 30;
  rutaMapa = [];
  sucursalNombre = '';
  sucursalLatitud = '';
  sucursalLongitud = '';
  distanciaKm = 0;
  distancia;
  distanciaRedonda = 0;
  vehiculo: any;
  vehiculo2: any;
  banderaVehiculo2 = false;
  vehiculoNombre;
  vehiculo2Nombre;
  vehiculoCombustiblePrecio: any;
  vehiculoCombustibleTipo;
  vehiculoPrecio;
  vehiculoRendimiento;
  vehiculoTrabajoReal;
  gastoCasetas = 0;
  operacionTrabajoReal;
  operacionTotalVehiculares = 0;
  operacionTotalVehicularesVista;
  // Fletes viáticos
  alojamientoDias = 0;
  desayunosDias = 0;
  comidasDias = 0;
  cenasDias = 0;
  alojamientoInput = 750;
  desayunosInput = 100;
  comidasInput = 150;
  cenasInput = 100;

  salarioChofer = 0;
  salarioAyudanteGene = 0; 
  conFlete;

  acarreosTotal = 0;
  acarreosTotalImp;
  desayunosTotal = 0;
  desayunosTotalImp;
  comidasTotal = 0;
  comidasTotalImp;
  cenasTotal = 0;
  cenasTotalImp;
  totalViaticos = 0;
  totalViaticosImp;
  // Fletes viáticos
  // Fletes traslados personal
  fletesAvion = 0;
  fletesAutobuses = 0;
  fletesTaxis = 0;
  fletesOtro = 0;
  fAvionInput = 0;
  fAutobusInput = 0;
  fTaxiInput = 0;
  fOtroInput = 0;
  subTotalAvionFletes = 0;
  subTotalAutobusFletes = 0;
  subTotalTaxiFletes = 0;
  subTotalOtroFletes = 0;
  totalFletesTraslados = 0;
  totalFletes = 0;
  totalFletesImp;
  // Fletes traslados personal
  // FLETES

  // Select´s
  selectMontaje = 'Montaje';
  selectVenta = 'Venta';
  selectRenta = 'Renta';
  // selectTipoCotizacion = ['Montaje', 'Venta/Renta'];
  selectTipoCotizacion = ['Montaje', 'Venta ' , 'Renta'];
  numeros = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  numerosViaticos = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  alturaSelect = [10, 20, 30, 40];
  personasSelect = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  numerosDescuento = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  imprevistos = [0, 200, 400, 600, 800, 1200, 1400, 1600];
  // Select´s

  banderaTipoCotizacion = false;

  loginLoader = false;

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService
  ) {
    this.idCliente = this.route.snapshot.paramMap.get('id');
    this.idContrato = this.route.snapshot.paramMap.get('idContrato');
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
  }

  ngOnInit() {
    // this.fechaCotizacion = moment().format('DD-MMM-YYYY');
    this.fechaCotizacion = moment().locale('es').format('LL');
    this.listarProductos();
    this.generarFlete();
    // this.mapa();
    setTimeout(() => {this.mapa(); }, 1500);
  }

  mapa() {
    var arrayMarcador = [];
    var mapaSelect;
    var map = L.map('map', { /*var map será nuestra variable global y principal, aquí la estamos seteando, asignándole L.map qie es el objeto vacío de la clase Leaflet que estamos llamando y enviándole el “map” que es el ID de nuestro DIV anteriormente creado. */
      dragging: true,
      touchZoom: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      boxZoom: true,
      tap: true,
      keyboard: false, contextmenu: true,
      contextmenuWidth: 140,
      contextmenuItems: [{
          text: 'Colocar Marcador',
          callback: colocarMarcador
      }, {
        text: 'Remover Marcador',
        callback: removeLayer

      }, {
          text: 'Centrar el mapa aqui',
          callback: centerMap
      }
        , '-', {
          text: 'Zoom +',
          // icon: 'images/zoom-in.png',
          callback: zoomIn
      }, {
          text: 'Zoom -',
         // icon: 'images/zoom-out.png',
          callback: zoomOut
      }
      ],
      fullscreenControl: true,
      fullscreenControlOptions: {
          position: 'topleft'
        }
      // contextmenu: true,
      // contextmenuWidth: 140,
    });

    map.setView([22.8196273667, -99.9503588558], 5);

    var osm = L.tileLayer('http://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', { /*Usamos el servicio como Tile para desplegar el mapa dependiendo del mosaico en pantalla.*/
      maxZoom: 19,
      maxNativeZoom: 19,
      zoomDelta: 0.25,
      zoomSnap: 0,
      attribution: 'Map data &copy; OpenStreetMap contributors' // opciones
    }).addTo(map); // aquí agregamos el mapa base (WMS) a el map (que es nuestra objeto map)

    var myIcon = L.icon({
      iconUrl: '../../../assets/images/marker-icon.png',
      iconSize: [30, 55],
      iconAnchor: [22, 55],
      popupAnchor: [-3, -76],
      shadowUrl: '../../../assets/images/marker-shadow.png',
      shadowSize: [68, 55],
      shadowAnchor: [22, 55]
    });

    // setup
    // search
    function centerMap (e) {
      map.panTo(e.latlng);
    }
    function colocarMarcador (e) {
      if (arrayMarcador.length === 0 || typeof(arrayMarcador.length) === 'undefined') {
        arrayMarcador.push('yes');
      //  console.log('pay');
      var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
      this.longitud = e.latlng.lng;
      this.latitud = e.latlng.lat;
      $('#latitud').val(this.latitud);
      $('#longitud').val(this.longitud);
      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(this.latitud, this.longitud),
          L.latLng($('#latitudDeSucursal').val(), $('#longitudDeSucursal').val())
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
         
           // console.log( distance );
        }).addTo(map);

        this.mapaSelect.hide();

      } else {
        removeLayer(e);
        arrayMarcador = [];
        this.mapaSelect.remove();
        this.mapaSelect = [];

        arrayMarcador.push('yes');
       // console.log('pay');
        var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
        this.longitud = e.latlng.lng;
        this.latitud = e.latlng.lat;
        $('#latitud').val(this.latitud);
        $('#longitud').val(this.longitud);

      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(this.latitud, this.longitud),
          L.latLng($('#latitudDeSucursal').val(), $('#longitudDeSucursal').val())
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
          // console.log( distance );
        }).addTo(map);
        this.mapaSelect.hide();
      }
      // mapaSelect.hide();
      // Machine route

    }

    function removeLayer(e) {
      map.eachLayer(function(layer) {
        if (layer.dragging) {
          map.removeLayer(layer);
        }
      });
      mapaSelect = [];
    }

    function zoomIn (e) {
      map.zoomIn();
    }

    function zoomOut (e) {
      map.zoomOut();
    }

    var geocoder = L.Control.geocoder({
      defaultMarkGeocode: false,
      collapsed: false
  })
  .on('markgeocode', function(e) {
      var bbox = e.geocode.bbox;
      var poly = L.polygon([
           bbox.getSouthEast(),
           bbox.getNorthEast(),
           bbox.getNorthWest(),
           bbox.getSouthWest()
      ]);
      map.fitBounds(poly.getBounds());
  })
  .addTo(map);
  }

  // Listar productos, vehículos y sucursal
  listarProductos() {
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.productos,
      'GET',
      null)
      .subscribe((response: any) => {
        if (response.Estatus === 200) {
          console.log(response);
          // Array de productos.
          for (const productos of response.Mensaje.productos) {
            this.arrayProductos.push({
              codigo: productos.codigo,
              descripcion: productos.descripcion,
              familia: productos.familia,
              pVenta: productos.precioVenta,
              pRenta: productos.precioRenta,
              peso: productos.peso,
              //
              // cantidad: productos.cliente.cantidad
              cantidad: 0
            });
          }
          this.selectProductos = this.arrayProductos;
          this.dtTrigger.next();
          // Sucursal
          this.sucursalNombre = response.Mensaje.sucursal.nombre;
          this.sucursalLatitud = response.Mensaje.sucursal.latitud;
          this.sucursalLongitud = response.Mensaje.sucursal.longitud;
          if ( this.sucursalNombre === 'Tijuana' || this.sucursalNombre === 'Monterrey' ) {
            this.iva = 0.08;
            this.formIva = '8%';
          } else {
            this.iva = 0.16;
            this.formIva = '16%';
          }
          // Sucursal
          for ( const vehiculo of response.Mensaje.vehiculos ) {
            this.arrayVehiculos.push({
              vehiculoId: vehiculo.vehiculoId,
              vehiculoNombre: vehiculo.nombre,
              vehiculoTipo: vehiculo.tipo,
              vehiculoCapacidad: vehiculo.capacidad,
              vehiculoRendimiento: vehiculo.rendimiento,
              vehiculoCombustible: vehiculo.combustible
            });
          }
          // console.log( this.arrayVehiculos );
          this.mapa();
        }
        this.generarManoDeObra();
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
    );
  }
  // Listar productos, vehículos y sucursal

  // Tipo de orden
  /*
  tipoOrden () {
    if ( this.ordenTipo === 'Montaje' ) {
      this.btnJustificacion = true;
    } else {
      this.btnJustificacion = false;
    }
  }
  */
  // Tipo de orden

  // Botón generar
  generarFlete() {
    //console.log('PAY');
    let vehiculo2Id;
    let vehiculo2CombustiblePrecio;
    let vehiculo2TrabajoReal;

    switch (true) {
      case this.sumaPeso >= 0 && this.sumaPeso < 1000: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 1000);
        // this.salarioChofer = 422;
        // this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso >= 1000 && this.sumaPeso <= 3500: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
        if ( this.sumaPeso >= 1000 && this.sumaPeso <= 3300 ) {
          // Silverado 3500
          this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3300);
        } else {
          // Ford F350
          this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
        }
        // this.salarioChofer = 422;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 3500 && this.sumaPeso <= 8000: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 8000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 8000 && this.sumaPeso <= 12000: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 12000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 12000 && this.sumaPeso <= 40000: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 40000: {
        //daremos el pago de los chiferesayudantes
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35; 
        //primero hacemos la dierencia del peso total para poder hacer un calculo de un nuevo vehiculo
        const diferenciaPeso = this.sumaPeso - 40000;
        //en base al peso de la diferencia, buscaeremos el vehiculo...
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
        this.banderaVehiculo2 = true;
        switch (true) {
          case diferenciaPeso > 0 && diferenciaPeso < 1000: {
            this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 1000);
            // this.salarioChofer = this.salarioChofer + 422;
            break;
          }
          case diferenciaPeso >= 1000 && diferenciaPeso <= 3500: {
            this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
            if ( diferenciaPeso >= 1000 && diferenciaPeso <= 3300 ) {
              // Silverado 3500
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3300);
            } else {
              // Ford F350
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
            }
            // this.salarioChofer = this.salarioChofer + 422;
            break;
          }
          case diferenciaPeso > 3500 && diferenciaPeso <= 8000: {
            console.log(this.sumaPeso);
            this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 8000);
            // this.salarioChofer = this.salarioChofer + 422;
            // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35;
            break;
          }
          case diferenciaPeso > 8000 && diferenciaPeso <= 12000: {
            this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 12000);
            // this.salarioChofer = this.salarioChofer + 422;
            // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35; 
            break;
          }
          case diferenciaPeso > 12000 && diferenciaPeso <= 40000: {
            console.log(this.sumaPeso);
            this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
            // this.salarioChofer = this.salarioChofer + 422;
            // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35;
            break;
            }
          }
       }
      default:
    }
    this.vehiculoId = this.vehiculo.vehiculoId;
    this.vehiculoNombre = this.vehiculo.vehiculoTipo;
    this.vehiculoCombustiblePrecio = this.vehiculo.vehiculoCombustible.precio;
    this.vehiculoTrabajoReal = this.vehiculo.vehiculoRendimiento.trabajoReal;
    // this.vehiculoCombustibleTipo = this.vehiculo.vehiculoCombustible.tipo;
    // this.vehiculoPrecio = this.vehiculo.vehiculoPrecio;

    if (this.banderaVehiculo2) {
      vehiculo2Id = this.vehiculo2.vehiculoId;
      this.vehiculo2Nombre = this.vehiculo2.vehiculoTipo;
      vehiculo2CombustiblePrecio = this.vehiculo2.vehiculoCombustible.precio;
      vehiculo2TrabajoReal = this.vehiculo2.vehiculoRendimiento.trabajoReal;
    }

    let mantenimiento = 0;

    // let estacionamiento = 0;

    // let lavadodeVehiculo = 0;
    
    // A
    this.distanciaMetros = $('#distanciaM').val();

    this.distanciaKm = (this.distanciaMetros) / 1000;
    this.distancia = Number(this.distanciaKm).toFixed(3);
    this.distancia = Intl.NumberFormat('es-MX').format(this.distancia);
    // Condicional para agregar el colchón
    if (this.sumaPeso  === 0)
    {
      this.distanciaRedonda = 0;
      this.salarioChofer = 0;
    } else {
      this.distanciaRedonda = Number(((this.distanciaKm * 2) + 50).toFixed(2));
       mantenimiento = 2.17 * this.distanciaRedonda;
       // console.log('entro');

      // estacionamiento = 200;
  
      // lavadodeVehiculo = 200;

      if (this.banderaVehiculo2)
      {
        mantenimiento = 2 * mantenimiento;

      // estacionamiento = estacionamiento + 200;
      // lavadodeVehiculo = lavadodeVehiculo + 200;
      }
    }
    // this.sumaPeso  === 0 ? this.distanciaRedonda = 0 : this.distanciaRedonda = this.distanciaKm + 50;
    // console.log('km: ' + this.distanciaRedonda);
    // Condicional para agregar el colchón
    this.gastoCombustible = (this.distanciaRedonda * this.vehiculoCombustiblePrecio) / this.vehiculoTrabajoReal;
     if(this.banderaVehiculo2)
    {
      this.gastoCombustible = this.gastoCombustible + ((this.distanciaRedonda * vehiculo2CombustiblePrecio) / vehiculo2TrabajoReal);
    }
    this.gastoCombustibleVista = Number((this.gastoCombustible).toFixed(2));
    this.gastoCombustibleVistaImp = Intl.NumberFormat('es-MX').format(this.gastoCombustibleVista);
    // this.gastoCombustible = (this.distanciaRedonda * this.precioGasolina) / this.rendimiento;

    //costo Mantenimiento

   

    // A
    // Operaciones
    // this.operacionTrabajoReal = (this.vehiculoCombustiblePrecio * this.distanciaRedonda) / this.vehiculoTrabajoReal;
    this.operacionTotalVehiculares = this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra) + mantenimiento;
    // this.operacionTotalVehiculares = this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra) + mantenimiento + estacionamiento + lavadodeVehiculo + this.salarioChofer + this.salarioAyudanteGene;

    //utilidad 

    this.operacionTotalVehiculares = (this.operacionTotalVehiculares * .10) + this.operacionTotalVehiculares;

    //imprevisto 10 por ciento

    this.operacionTotalVehiculares = (this.operacionTotalVehiculares * .5) + this.operacionTotalVehiculares;

    if (this.checkRecoleccion)
    { 
      this.operacionTotalVehiculares = this.operacionTotalVehiculares * 2;
    }

    if (this.conFlete === 'true' && (this.ordenTipo === 'Venta' || this.ordenTipo === 'Renta'))
    {

        this.operacionTotalVehiculares = 0;
        //console.log('pez');
    }
    


    this.operacionTotalVehicularesVista = Number(this.operacionTotalVehiculares).toFixed(2);
    this.operacionTotalVehicularesVista = Intl.NumberFormat('es-MX').format(this.operacionTotalVehicularesVista);
    // this.operacionTotalVehiculares = (this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra)).toFixed(2);
    // console.log( this.operacionTotalVehiculares );
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    // Mandar a llamar al método que involucra sub total y total
    this.manoDeObra();

    for (const rowProductos of this.arrayProductos) {
      let rowCodigo;
      let rowDescripcion;
      let rowCantidadSolicitada;
      let rowCantidadAFisico;
      let rowOriginalAFisico;
      let rowCantidadFaltante;
      rowCodigo = rowProductos.codigo;
      rowDescripcion = rowProductos.descripcion;
      rowCantidadSolicitada = rowProductos.cantidad;
      rowOriginalAFisico = rowProductos.aFisico;
      // Operaciones
      rowCantidadAFisico = rowProductos.aFisico - this.cantidadColchon;
      rowCantidadFaltante = Math.abs((rowCantidadAFisico) - rowCantidadSolicitada);
    }
  }
  // Botón generar
  cambiarRojito()
  {
    this.banderaTipoCotizacion = false;
    this.generarFlete();
    if (this.ordenTipo === 'Venta') {
      this.boolOrdenTipo = false;
    } else {
      this.boolOrdenTipo = true;
    }
  }
  agregarProducto(producto) {

    if (!this.ordenTipo) {
      Swal('Espera', 'Primero selecciona tu tipo de cotizacion', 'warning');
      this.banderaTipoCotizacion = true;
      /*
      $('button').click(function() {
        $('html,body').animate({
            scrollTop: $('#divSelector').offset()},
            'slow');
      });
      */
    } else {
      /*
      $('button').click(function() {
        $('html,body').animate({
            scrollTop: $('#agregarProductosTabla').offset()},
            'slow');
      });
      */
    }
    const codigoProducto = producto.codigo;
    const descripcionProducto = producto.descripcion;
    const precioVenta = producto.pVenta;
    const precioRentaMensual = producto.pRenta;
    const pesoUnitario = producto.peso;
    const familia = producto.familia;
    const cantidadProducto = 0;
    const importeRenta = 0;
    const importeVenta = 0;
    const pesoTotal = 0;
    const productoPorCodigo = this.material.find(function(element) { return element.codigo === codigoProducto && element.descripcion === descripcionProducto ; });
    // Insertar elementos en una nuevo Array (this.material.push)
    if (productoPorCodigo === undefined) {
        // console.log('Agregando producto');
        // No dejar insertar el mismo artículo más de dos veces, si no está en la tabla agregarlo...
        this.material.push({
          codigo: codigoProducto,
          familia: familia,
          descripcion: descripcionProducto,
          precioV: precioVenta,
          precioR: precioRentaMensual,
          peso: pesoUnitario,
          cantidad: cantidadProducto,
          importeR: importeRenta,
          importeV: importeVenta,
          pesoT: pesoTotal,
          // . . .
          importeRenta: 0,
          importeVenta: 0,
          importePeso: 0
        });
      } else {
        // console.log('Producto repetido');
        Swal('Producto duplicado', 'Ya haz agregado este producto a la lista: ' + codigoProducto, 'info');
      }
  }

  calculosProducto(producto) {
    // console.log('Suma de productos');
    const cantidad: Number = $('#' + producto.codigo).val();

    let productoSeleccionado;
    productoSeleccionado = this.material.find(row => row.codigo === producto.codigo);
    // Obtener elementos para cálculos
    // Importe Renta
    const precioRenta = productoSeleccionado.precioR;
    const importeRenta = Number(cantidad) * precioRenta;
    // Calculo importe venta
    const precioVenta = productoSeleccionado.precioV;
    const importeVenta = Number(cantidad) * precioVenta;
    // Peso Total
    const pesoUnitario = productoSeleccionado.peso;
    const pesoTotal = Number(cantidad) * pesoUnitario;
    // Insertar cálculos a array Materiales
    productoSeleccionado.cantidad = cantidad;

    // ====== Aumento a producto unitario =============
    const importeAProducto = productoSeleccionado.precioR;
    // ====== Aumento a producto unitario =============

    // productoSeleccionado.importeR = importeRenta;
    productoSeleccionado.importeR = (Math.abs(Number(importeAProducto) * Number(this.porcentajeAumento) / 100 + Number(importeAProducto)) * Number(cantidad)).toFixed(4);
    productoSeleccionado.importeV = (importeVenta).toFixed(4);
    this.importeRentaImp = Intl.NumberFormat('es-MX').format(productoSeleccionado.importeR);
    productoSeleccionado.pesoT = (pesoTotal).toFixed(4);
    this.importePesoImp = Intl.NumberFormat('es-MX').format(productoSeleccionado.pesoT);

    // Se recorrerá el arreglo de productos buscando sus sumas totales
    // Se utilizan variables globales para poder mostrar el valor en la vista
    this.sumaRenta = 0;
    this.sumaCantidad = 0;
    this.sumaPeso = 0;
    this.sumaVenta = 0;
    this.material.forEach(element => {
      this.sumaVenta = Number((this.sumaVenta + Number(element.importeV)).toFixed(4));
      // this.sumaRenta = this.sumaRenta + Number(element.importeR);
      this.sumaRenta = Number((Math.round(this.sumaRenta + Number(element.importeR))).toFixed(4));
      this.sumaRentaImp = Intl.NumberFormat('es-MX').format(this.sumaRenta);
      this.sumaCantidad = this.sumaCantidad + Number(element.cantidad);
      this.sumaCantidadImp = Intl.NumberFormat('es-MX').format(this.sumaCantidad);
      this.sumaPeso = Number(( this.sumaPeso + Number(element.pesoT)).toFixed(4));
      this.sumaPesoImp = Intl.NumberFormat('es-MX').format(this.sumaPeso);

    });
    // Renta diaria
    this.rentaDiaria = Number((this.sumaRenta / 30).toFixed(4));
    this.rentaDiariaImp = Intl.NumberFormat('es-MX').format(this.rentaDiaria);
    // Renta 7 días
    this.rentaSDias = Number((this.sumaRenta / 30 * 7).toFixed(4));
    this.rentaSDiasImp = Intl.NumberFormat('es-MX').format(this.rentaSDias);
    // Renta 15 días
    this.rentaQDias = Number((this.sumaRenta / 2).toFixed(4));
    this.rentaQDiasImp = Intl.NumberFormat('es-MX').format(this.rentaQDias);
    //    this.porcentajeAumento();
    // Aumento a producto unitario
    // const importeAProducto = productoSeleccionado.precioR;
    // this.aumentoProducto = Math.abs(Number(importeAProducto) * Number(this.porcentajeAumento) / 100 + Number(importeAProducto));
    // Aumento a producto unitario
    this.manoDeObra();
    this.generarManoDeObra();
    this.generarFlete();
  }

  descuento () {
    // Math.abs devuelve la cantidad absoluta de la cantidad dada en el parámetro.
    // this.resultadoPorcentajeDescuento = Math.abs((this.sumaRenta * this. porcentajeDescuento) / 100 - this.sumaRenta);
    this.resultadoPorcentajeDescuento2 =  Number ((Math.abs((Number(this.resultadoDiasRenta) * Number(this.porcentajeDescuento)) / 100 - Number(this.resultadoDiasRenta))));
    this.resultadoPorcentajeDescuento = Intl.NumberFormat('es-MX').format(this.resultadoPorcentajeDescuento2);
    // console.log(Intl.NumberFormat('es-MX').format(this.resultadoPorcentajeDescuento));
    this.manoDeObra();
  }

  aumento () {
    this.material.forEach(element => {
      const productoSeleccionado = this.material.find(e => e.codigo === element.codigo);
      // productoSeleccionado.importeRenta = Math.abs(Number(element.rentaMensual) * (Number(this.porcentajeAumento) / 100) + element.rentaMensual);
      productoSeleccionado.importeR = ((Math.abs(Number(element.rentaMensual) * (Number(this.porcentajeAumento) / 100) + element.rentaMensual)) * element.cantidad).toFixed(2);
      // Se vuelve a llamar al método: this.calculosProducto( productoSeleccionado ), para que en el ngModelChange vuelva a hacer las operaciones correspondientes.
      this.calculosProducto( productoSeleccionado );
    });
    this.sumaVenta = 0;
    this.sumaRenta = 0;
    this.material.forEach(element => {
      this.sumaVenta = this.sumaVenta + Number(element.importeV);
      // this.sumaRenta = this.sumaRenta + Number(element.importeR);
      this.sumaRenta = Math.round(this.sumaRenta + Number(element.importeR));
      //this.sumaCantidad = this.sumaCantidad + Number(element.cantidad);
      //this.sumaPeso = this.sumaPeso + Number(element.pesoT);
    });
    // Renta diaria
    this.rentaDiaria = Number((this.sumaRenta / 30).toFixed(4));
    this.rentaDiariaImp = Intl.NumberFormat('es-MX').format(this.rentaDiariaImp);
    // this.rentaDiaria = this.sumaRenta / 30;
    // Renta 7 días
    this.rentaSDias = Number((this.sumaRenta / 30 * 7).toFixed(4));
    this.rentaSDiasImp = Intl.NumberFormat('es-MX').format(this.rentaSDiasImp);
    // Renta 15 días
    this.rentaQDias = Number((this.sumaRenta / 2).toFixed(4));
    this.rentaQDiasImp = Intl.NumberFormat('es-MX').format(this.rentaQDiasImp);
    this.renta();
    // . . .
    this.manoDeObra();
  }

  // Eliminar fletes...
  /*fletesEntrega() {
    this.fletesTotal = Number((this.numeroViajes * this.unidadViaje).toFixed(4));
    // Se vuelve a llamar a la función manoDeObra para que onChange haga la suma sin importar que se modifique algún valor posteriormente.
    this.manoDeObra();
  }*/

  manoDeObra () {
    this.subTotal = Number(Number(this.resultadoPorcentajeDescuento2 + this.totalTotal + this.totalFletes).toFixed(4));
    this.subtotalImp = Intl.NumberFormat('es-MX').format(this.subTotal);
    let ventaTotal = Number((this.sumaVenta + (this.sumaVenta * Number(this.iva))).toFixed(4));
    this.ventaTotal = Intl.NumberFormat('es-MX').format(ventaTotal);
    // this.subTotal = Number((Number(this.sumaRenta) + this.totalTotal + this.fletesTotal + this.totalFletes).toFixed(4));
    // this.subTotal = Number((Number(this.sumaRenta) + this.totalTotal + this.fletesTotal).toFixed(4));
    if(this.ordenTipo === 'Venta') {
      let subTotalConIva = ((this.subTotal * Number(this.iva)) + this.subTotal);
      this.subTotal = 0;
      let costoTotalOperacion = Number((ventaTotal + subTotalConIva).toFixed(4));
      this.costoTotal = Intl.NumberFormat('es-MX').format(costoTotalOperacion);
    } else {
      let costoTotalOperacion = Number(((Number(this.subTotal) * Number( this.iva ) ) + this.subTotal).toFixed(4));
      this.costoTotal = Intl.NumberFormat('es-MX').format(costoTotalOperacion);
    }
  }

  renta () {
    this.resultadoDiasRenta = Number((Math.abs(this.sumaRenta / 30) * this.diasDeRenta).toFixed(4));
    this.resultadoDiasRentaImp = Intl.NumberFormat('es-MX').format(this.resultadoDiasRenta);
    this.fechaFin = moment().add('days', this.diasDeRenta).locale('es').format('LL');
    this.descuento();
  }

  eliminarMaterial(producto) {
    // console.log(producto);
    const nombreProducto = this.material.findIndex( productoEncontrado => productoEncontrado.codigo === producto );
    this.material.splice(nombreProducto, 1);
    this.aumento();
    // Prueba
    if (this.material.length === 0) {
     console.log('no hay material');
     this.sumaCantidad = 0;
     this.sumaPeso = 0;
     this.generarFlete();
    }
    // this.agregarProducto(producto);
    // this.calculosProducto(producto);
  }

  controlCotizacion() {
    /*
    if ( !$('#DIRECCIONDELAOBRA').val() || !$('#longitud').val() ) {
      Swal( 'Falta información', 'Por favor, agrega la dirección y la ubicación de la obra en el mapa', 'error' );
    }
      if (this.formDescripcion === '') {
        Swal( 'Falta información', 'Por favor, agrega el nombre de la obra', 'error' );
       }
       */
      if(this.ordenTipo === 'Venta' && this.conFlete === 'true') {
           this.enviarCotizador();
      } else {
        if ( !$('#DIRECCIONDELAOBRA').val()) {
          Swal('Falta información', 'Agrega la dirección de la obra', 'error');
        } else if ( !$('#longitud').val()) {
          Swal('Falta información', 'Agrega la ubicación de la obra', 'error');
        } else if (this.formDescripcion === '') {
          Swal('Falta información', 'Agrega el nombre de la obra', 'error');
        } else {
          this.enviarCotizador();
        }
      }

    }


  enviarCotizador () {
    if(this.ordenTipo === 'Venta' && this.conFlete === 'true') {
      var latitud = 0;
      var longitud = 0;
    } else {
      latitud = $('#latitud').val();
      longitud = $('#longitud').val();
    }

      let banderaFlete = false;

      if (this.conFlete === 'true') {
        banderaFlete = true;
      }

    const jsonData = {
      tipoCotizacion: this.ordenTipo,
      conFlete: banderaFlete,
      justificacion: this.formJustificacion,
      montaje: this.montaje,
      desmontaje: this.desmontaje,
      noFletes: this.numeroViajes,
      // costoFlete: this.unidadViaje,
      porcentajeDescuento: this.porcentajeDescuento,
      porcentajeAumento: this.porcentajeAumento,
      clienteCotizado: this.formCliente,
      contactoCotizado: this.formContacto,
      obraCotizada: this.formObra,
      descripcion: this.formDescripcion,
      telefonoCotizado: this.formTelefono,
      celularCotizado: this.formCelular,
      emailCotizado: this.formEmail,
      fechaCotizada: this.fechaFin,
      productos: this.material,
      cantidadDias: this.diasDeRenta,
      latitud: latitud,
      longitud: longitud,
      // Mano de obra
      manoObra: {
        altura: this.altura,
        personas: this.personas,
        jornal: this.jornales,
        accesos: this.Accesos,
        descargas: this.Descargas,
        tiemposMuertos: this.Tiempos,
        acarreos: this.Acarreos,
        tiemposExtras: this.Extras,
        diasInhabiles: this.Inhabiles,
        tramites: this.Tramites,
        certificados: this.Certificados,
        consumibles: this.Gastos,
        equipoSeguridad: this.Equipo,
        preparacionMaterial: this.Preparacion,
        imprevistos: this.Imprevistos,
        comidas: this.Comidas,
        avionCosto: this.avionCosto,
        avionViajes: this.avionViajes,
        avionCheck: this.avionCheck,
        autobusCosto: this.autobusCosto,
        autobusViajes: this.autobusViajes,
        autobusCheck: this.autobusCheck,
        barcoCosto: this.barcoCosto,
        barcoViajes: this.barcoViajes,
        barcoCheck: this.barcoCheck,
        taxiCosto: this.taxiCosto,
        taxiViajes: this.taxiViajes,
        otroCosto: this.otroCosto,
        otroViajes: this.otroViajes,
        nRendimiento: this.nRendimiento,
        rendimiento: this.rendimiento
      },
      // Fletes
      flete: {
        distancia: this.distanciaRedonda,
        fecha: this.fechaCotizacion,
        gastoCombustible: this.gastoCombustibleVista,
        gastoCasetas: this.gastoCasetas,
        gastoExtra: this.gastoExtra,
        operador: 1,
        recoleccion: this.checkRecoleccion,
        vehiculoId: this.vehiculoId,
        dias: 1,
        viaticos: {
          alojamientoCosto: this.alojamientoInput,
          alojamientoDias: this.alojamientoDias,
          desayunoCosto: this.desayunosInput,
          desayunoDias: this.desayunosDias,
          comidaCosto: this.comidasInput,
          comidaDias: this.comidasDias,
          cenaCosto: this.cenasInput,
          cenaDias: this.cenasDias,
          avionCosto: this.fAvionInput,
          avionViajes: this.fletesAvion,
          autobusCosto: this.fAutobusInput,
          autobusViajes: this.fletesAutobuses,
          taxiCosto: this.fTaxiInput,
          taxiViajes: this.fletesTaxis,
          otroCosto: this.fOtroInput,
          otroViajes: this.fletesOtro,
        }
      }
      // Fletes
    };
    // console.log( jsonData );

    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.crear,
      'POST',
      jsonData
    ).subscribe((response: any) => {
      // console.log(response);
      this.loginLoader = false;
      if ( response.Estatus === 200 || response.Estatus === 201 ) {
        Swal('Correcto', 'Cotización guardada', 'success');
        this.ruta.navigate(['dashboard/verCotizaciones', response.Mensaje.id]);
      } else {
        Swal('Error', response.Mensaje, 'error');
      }
    }, err => {
      console.log(err);
      this.loginLoader = false;
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }


  generarManoDeObra() {
    let porcentajeRendimiento: number = 12.5;
    let nRendimiento: number;
    let procentaje: number;

    let tarimas: number = 40;
    let juntas: number = 40;
    let crucetas: number = 80;
    let marcos: number = 40;
    let vallas: number = 100;
    let sm8: number = 42;
    let templete: number = 100;
    let bases: number = 40;
    let ruedas: number = 40;
    let montantes: number = 30;
    let mensulas: number = 25;
    let rodapies: number = 30;
    let baseDeArranque: number = 30;
    let puntales: number = 20;
    let escalonesMetalicos: number = 30;
    let vigasExtencibles: number = 10;
    let vigadales: number = 20;
    let escalerasMarinas: number = 30;
    let engancheParalelo: number = 30;
    let vigasH20: number = 20;

    switch (true) {
      case this.altura <= 10 && this.altura >= 0:
      {
        procentaje = 100;
        break;
      }
      case this.altura <= 20 && this.altura >= 11:
      {
        nRendimiento = 2;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura <= 30 && this.altura >= 21:
      {
        nRendimiento = 3;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura <= 40 && this.altura >= 31:
      {
        nRendimiento = 4;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura >= 41:
      {
        nRendimiento = 5;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
    }

    const rendimientoMarcos =  (procentaje / 100) * marcos;
    const rendimientoTarimas =  (procentaje / 100) * tarimas;
    const rendimientoCrucetas =  (procentaje / 100) * crucetas;
    const rendimientoVallas =  (procentaje / 100) * vallas;
    const rendimientoSm8 =  (procentaje / 100) * sm8;
    const rendimientoJuntas =  (procentaje / 100) * juntas;
    const rendimientoTemplete = ( procentaje / 100 ) * templete;
    const rendimientoBases = ( procentaje / 100 ) * bases;
    const rendimientoRuedas = ( procentaje / 100 ) * ruedas;
    const rendimientoMontantes = ( procentaje / 100 ) * montantes;
    const rendimientoMensulas = ( procentaje / 100 ) * mensulas;
    const rendimientoRodapies = ( procentaje / 100 ) * rodapies;
    const rendimientoBaseDeArranque = ( procentaje / 100 ) * baseDeArranque;
    const rendimientoPuntales = ( procentaje / 100 ) * puntales;
    const rendimientoEscalonesMetalicos = ( procentaje / 100 ) * escalonesMetalicos;
    const rendimientoVigasExtencibles = ( procentaje / 100 ) * vigasExtencibles;
    const rendimientoVigadales = ( procentaje / 100 ) * vigadales;
    const rendimientoEscalerasMarinas = ( procentaje / 100 ) * escalerasMarinas;
    const rendimientoEngancheParalelo = ( procentaje / 100 ) * engancheParalelo;
    const rendimientoVigasH20 = ( procentaje / 100 ) * vigasH20;

    this.rendimiento = procentaje;

    this.recorridoMaterial(
      rendimientoCrucetas,
      rendimientoJuntas,
      rendimientoMarcos,
      rendimientoSm8,
      rendimientoVallas,
      rendimientoTarimas,
      rendimientoTemplete,
      rendimientoBases,
      rendimientoRuedas,
      rendimientoMontantes,
      rendimientoMensulas,
      rendimientoRodapies,
      rendimientoBaseDeArranque,
      rendimientoPuntales,
      rendimientoEscalonesMetalicos,
      rendimientoVigasExtencibles,
      rendimientoVigadales,
      rendimientoEscalerasMarinas,
      rendimientoEngancheParalelo,
      rendimientoVigasH20
    );

  }

  recorridoMaterial(
    rendimientoCrucetas,
    rendimientoJuntas,
    rendimientoMarcos,
    rendimientoSm8,
    rendimientoVallas,
    rendimientoTarimas,
    rendimientoTemplete,
    rendimientoBases,
    rendimietoRuedas,
    rendimientoMontantes,
    rendimientoMensulas,
    rendimientoRodapies,
    rendimientoBaseDeArranque,
    rendimientoPuntales,
    rendimientoEscalonesMetalicos,
    rendimientoVigasExtencibles,
    rendimientoVigadales,
    rendimientoEscalerasMarinas,
    rendimientoEngancheParalelo,
    rendimientoVigasH20) {
    var sumaRendimientoJunta:number = 0;
    var sumaRendimientoCrucetas:number = 0;
    var sumaRendimientoMarcos:number = 0;
    var sumaRendimientoSm8:number = 0;
    var sumaRendimientoVallas:number = 0;
    var sumaRendimientoTarimas:number = 0;
    var sumaRendimientoTemplete: number = 0;
    var sumaRendimientoBases: number = 0;
    var sumaRendimietoRuedas: number = 0;
    var sumaRendimientoPuntales: number = 0;
    var sumaRendimientoEscalonesMetalicos: number = 0;
    var sumaRendimientoVigasExtencibles: number = 0;
    var sumaRendimientoVigadales: number = 0;
    var sumaRendimientoVigasH20: number = 0;

    this.material.forEach(element => {

      switch (element.familia) {
        case 'JUNTAS': {
          sumaRendimientoJunta = sumaRendimientoJunta + ((Number(element.cantidad) * 8) / rendimientoJuntas);
          break;
        }
        case 'MARCOS': {
          sumaRendimientoMarcos = sumaRendimientoMarcos + ((Number(element.cantidad) * 8) / rendimientoMarcos);
          break;
        }
        case 'CRUCETAS': {
          sumaRendimientoCrucetas = sumaRendimientoCrucetas + ((Number(element.cantidad) * 8) / rendimientoCrucetas);
          break;
        }
        case 'SM-8': {
          let cincoCaracteres = element.descripcion.slice(0, 5);
          if (cincoCaracteres === 'TRAVE') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'DIAGO') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'LARGU') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'BASE ') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoBaseDeArranque);
          } else if (cincoCaracteres === 'MONTA') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoMontantes);
          } else if (cincoCaracteres === 'RODAP') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoRodapies);
          } else if (cincoCaracteres === 'MENSU') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoMensulas);
          } else if (cincoCaracteres === 'ESCAL') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoEscalerasMarinas);
          } else if (cincoCaracteres === 'ENGAN') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoEngancheParalelo);
          }
            break;
        }
        case 'TARIMAS': {
          sumaRendimientoVallas = sumaRendimientoVallas + ((Number(element.cantidad) * 8) / rendimientoTarimas);
          break;
        }
        case 'VALLAS': {
          sumaRendimientoTarimas = sumaRendimientoTarimas + ((Number(element.cantidad) * 8) / rendimientoVallas);
          break;
        }
        case 'TEMPLETE': {
          let cincoCaracteres = element.descripcion.slice(0, 5);
          if ( cincoCaracteres === 'CUADR' ) {
            sumaRendimientoTemplete = sumaRendimientoTemplete + ( (Number(element.cantidad) * 8) / rendimientoTemplete );
          }
          break;
        }
        case 'BASES': {
          sumaRendimientoBases = sumaRendimientoBases + ((Number(element.cantidad) * 8) / rendimientoBases);
          break;
        }
        case 'RUEDAS': {
          sumaRendimietoRuedas = sumaRendimietoRuedas + ((Number(element.cantidad) * 8) / rendimietoRuedas);
          break;
        }
        case 'PUNTALES': {
          sumaRendimientoPuntales = sumaRendimientoPuntales + ((Number(element.cantidad) * 8) / rendimientoPuntales);
          break;
        }
        case 'ESCALONES METALICOS': {
          sumaRendimientoEscalonesMetalicos = sumaRendimientoEscalonesMetalicos + ((Number(element.cantidad) * 8) / rendimientoEscalonesMetalicos);
          break;
        }
        case 'VIGAS EXTENCIBLES': {
          sumaRendimientoVigasExtencibles = sumaRendimientoVigasExtencibles + ((Number(element.cantidad) * 8) / rendimientoVigasExtencibles);
          break;
        }
        case 'VIGADALES Y DUELAS': {
          sumaRendimientoVigadales = sumaRendimientoVigadales + ((Number(element.cantidad) * 8) / rendimientoVigadales);
          break;
        }
        case 'VIGAS H20': {
          sumaRendimientoVigasH20 = sumaRendimientoVigasH20 + ((Number(element.cantidad) * 8) / rendimientoVigasH20);
          break;
        }

      }

    });
    if ( this.ordenTipo === 'Venta' || this.ordenTipo === 'Renta' ) {
      this.cantidadHoras = 0;
      this.jornales = (this.cantidadHoras / 8);
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    } else if ( this.ordenTipo === 'Montaje' ) {
      this.cantidadHoras = sumaRendimientoCrucetas + sumaRendimientoJunta + sumaRendimientoMarcos + sumaRendimientoSm8 + sumaRendimientoTarimas + sumaRendimientoVallas + sumaRendimientoTemplete + sumaRendimientoVigasH20 + 8;
      this.jornales = (this.cantidadHoras / 8);
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    }
    // console.log(sumaRendimientoSm8);
    this.jornadas();
  }

  jornadas() {
    var cantidadHorasFloat = ((this.cantidadHoras + this.pasarSumasTemporales));
    this.cantidadHorasTotal = Number(cantidadHorasFloat.toFixed(4));
    this.cantidadHorasTotalImp = Intl.NumberFormat('es-MX').format(this.cantidadHorasTotal);
    // var jornalesFloat = (cantidadHorasFloat / 8);
    if ( this.ordenTipo === 'Montaje' ) {
      var jornalesFloat = (cantidadHorasFloat / 8);
      this.jornales = Math.ceil(Number(jornalesFloat.toFixed(4)));
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    } else if ( this.ordenTipo === 'Venta' ) {
      var jornalesFloarDos = (cantidadHorasFloat / 8);
      this.jornales = Math.ceil(Number(jornalesFloarDos.toFixed(4)));
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    }
    // this.jornales = Math.ceil(Number(jornalesFloat.toFixed(4)));
    if (this.jornales !== 0) {
      this.sumaConceptosVarios();
    }
    this.horasPersonas = Math.ceil(this.cantidadHorasTotal / this.personas);
    this.jornalesPersonas = Math.ceil(jornalesFloat / this.personas);
  }

  sumaConceptosVarios() {
    let suma: number;
    suma = Number(this.Equipo) + Number(this.Preparacion)
    + Number(this.Gastos) + Number(this.Tramites) + Number(this.Certificados)
    + Number(this.Comidas) + (Number(this.Inhabiles) * 850);
    this.costoTotalManoObra = Number(suma);
    let trabajo;
    if (this.jornales === 1) {
      trabajo = 0;
    } else {
      trabajo = this.jornales * 850;
    }

    this.costoPersonasPorMontaje = trabajo;

    trabajo = Number(suma) + Number(trabajo);
    trabajo = trabajo + (((Number(this.Imprevistos) / 100) * trabajo ));
    this.montaje =  ((trabajo) * 2) / 3;
    this.desmontaje =  ((trabajo) * 1) / 3;

    this.montaje = Number(this.montaje.toFixed(4));
    this.montajeImp = Intl.NumberFormat('es-MX').format(this.montaje);
    this.desmontaje = Number(this.desmontaje.toFixed(4));
    this.desmontajeImp = Intl.NumberFormat('es-MX').format(this.desmontaje);

    this.totalTotal = Number(trabajo) + this.sumaTrasladosTotal;
    this.totalTotal = Number(this.totalTotal.toFixed(4));
    this.totalTotalImp = Intl.NumberFormat('es-MX').format(this.totalTotal);

    this.manoDeObra();
  }

  variablesTemporales() {
    this.pasarSumasTemporales = Number(this.Accesos) + Number(this.Descargas) + Number(this.Tiempos) + Number(this.Acarreos) + Number(this.Extras);
    this.jornadas();
  }

  // Esta funcion solo es para hacer el despliegue del div
  desplegarManoObra() {
    if (this.manoDeObraCollapse) {
      this.manoDeObraCollapse = false;
      this.iconoMano = 'mdi-arrow-down-bold-circle-outline';
    } else {
      this.manoDeObraCollapse = true;
      this.iconoMano = 'mdi-arrow-up-bold-circle-outline';
    }
  }

  // Esta funcion solo es para hacer el despliegue del div
  desplegarFlete() {
    if (this.fletesCollapse) {
      this.fletesCollapse = false;
      this.iconoFlete = 'mdi-arrow-down-bold-circle-outline';
      this.generarFlete();
    } else {
        this.fletesCollapse = true;
        this.iconoFlete = 'mdi-arrow-up-bold-circle-outline';
        this.generarFlete();
    }
  }

  

  trasladosChallenge() {
    let sumaAvionOp = this.avionCosto * this.avionViajes;
    this.sumaAvion = Intl.NumberFormat('es-MX').format(sumaAvionOp);
    this.avionCheck = $('#avionCheck').prop('checked');
    if (this.avionCheck) {
      sumaAvionOp = sumaAvionOp * 2;
      this.sumaAvion = Intl.NumberFormat('es-MX').format(sumaAvionOp);
    }
    if (!sumaAvionOp) {
      sumaAvionOp = 0;
      this.sumaAvion = 0;
    }
      let sumaAutobusOp = this.autobusCosto * this.autobusViajes;
      this.sumaAutobus = Intl.NumberFormat('es-MX').format(sumaAutobusOp);
      this.autobusCheck = $('#autobusCheck').prop('checked');
    if (!sumaAutobusOp) {
      sumaAutobusOp = 0;
       this.sumaAutobus = 0;
    }
    if (this.autobusCheck) {
      sumaAutobusOp = sumaAutobusOp * 2;
      this.sumaAutobus = Intl.NumberFormat('es-MX').format(sumaAutobusOp);
    }
    let sumaBarcoOp = this.barcoCosto * this.barcoViajes;
    this.sumaBarco =  Intl.NumberFormat('es-MX').format(sumaBarcoOp);
    if (!sumaBarcoOp) {
      this.sumaBarco = 0;
      sumaBarcoOp = 0;
    }
    this.barcoCheck = $('#barcoCheck').prop('checked');
    if (this.barcoCheck) {
      sumaBarcoOp = sumaBarcoOp * 2;
      this.sumaBarco =  Intl.NumberFormat('es-MX').format(sumaBarcoOp);
    }
    let sumaTaxiOp = this.taxiCosto * this.taxiViajes;
    this.sumaTaxi = Intl.NumberFormat('es-MX').format(sumaTaxiOp);
    if (!sumaTaxiOp) {
      sumaTaxiOp = 0;
      this.sumaTaxi = 0;
    }
    let sumaOtroOp = this.otroCosto * this.otroViajes;
    this.sumaOtro = Intl.NumberFormat('es-MX').format(sumaOtroOp);
    if (!sumaOtroOp) {
      sumaOtroOp = 0;
      this.sumaOtro = 0;
    }
    this.sumaTrasladosTotal = sumaAutobusOp + sumaAvionOp + sumaBarcoOp + sumaTaxiOp + sumaOtroOp;
    this.sumaTrasladosTotalImp = Intl.NumberFormat('es-MX').format(this.sumaTrasladosTotal);

    this.sumaConceptosVarios();
  }

  fletesViaticos () {
    // Acarreos
    this.acarreosTotal = this.alojamientoDias * this.alojamientoInput;
    this.acarreosTotalImp = Intl.NumberFormat('es-MX').format(this.acarreosTotal);
    // Desayunos
    this.desayunosTotal = this.desayunosDias * this.desayunosInput;
    this.desayunosTotalImp = Intl.NumberFormat('es-MX').format(this.desayunosTotal);
    // Comidas
    this.comidasTotal = this.comidasDias * this.comidasInput;
    this.comidasTotalImp = Intl.NumberFormat('es-MX').format(this.comidasTotal);
    // Cenas
    this.cenasTotal = this.cenasDias * this.cenasInput;
    this.cenasTotalImp = Intl.NumberFormat('es-MX').format(this.cenasTotal);
    // Total Viáticos
    this.totalViaticos = this.acarreosTotal + this.desayunosTotal + this.comidasTotal + this.cenasTotal;
    this.totalViaticosImp = Intl.NumberFormat('es-MX').format(this.totalViaticos);
    // Total
    // this.totalFletes = this.totalViaticos + this.totalFletesTraslados + Number(this.operacionTotalVehiculares);
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    // Mandar a llamar al método que involucra sub total y total
    this.manoDeObra();
  }

  fletesTraslados () {
    // Avión fletes
    this.subTotalAvionFletes = this.fletesAvion * this.fAvionInput;
    // Autobús fletes
    this.subTotalAutobusFletes = this.fletesAutobuses * this.fAutobusInput;
    // Taxis fletes
    this.subTotalTaxiFletes = this.fletesTaxis * this.fTaxiInput;
    // Otro fletes
    this.subTotalOtroFletes = this.fletesOtro * this.fOtroInput;
    // Total Traslados
    this.totalFletesTraslados = this.subTotalAvionFletes + this.subTotalAutobusFletes + this.subTotalTaxiFletes + this.subTotalOtroFletes;
    // Total
    // this.totalFletes = this.totalViaticos + this.totalFletesTraslados + Number(this.operacionTotalVehiculares);
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    // Mandar a llamar al método que involucra sub total y total
    this.manoDeObra();
  }

    formatDollar(num) {
    let p = num.toFixed(2).split('.');
    return '$' + p[0].split('').reverse().reduce(function(acc, num, i, orig) {
        return num + (i && !(i % 3) ? ' , ' : '') + acc;
    }, '') + '.' + p[1];
  }

  imprimir() {
    swal({
      title: 'Atencion',
      text: 'Deberias guadar la obra antes de impirmir, ¿No quieres perder los datos o si!?',
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, deseo guadar!'
    }).then((result) => {
      if (result.value) {
        this.enviarCotizador();
      }
  });
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/cotizador/cotizador.component.ts